export const achievementConditions = [
    "Наибольшее количество задач",
    "Наибольший объем SP по задачам",
    "Наибольший общий объем SP",
    "Вручную"
];